import React from 'react';

import OutOfView from '../Lazyload/OutOfView';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import "swiper/css/thumbs";

const Slider = ({ className, children, swiperRef, autoplay = false }) => {

    const onOutHandler = (entry, observer) => {
        if (autoplay === true) {
            if (entry.isIntersecting) {
                swiperRef.current.swiper.autoplay.start();
            }
            else {
                swiperRef.current.swiper.autoplay.stop();
            }
        }
        else {
            observer.disconnect();
        }
    }

    return (
        <OutOfView className={className} onOutCallback={onOutHandler}>{children}</OutOfView>
    )
}

export default Slider;